import { WrongBaleLink } from "utils/regex";

export enum TitleAndTextErrors {
  OnlyEnglish = "OnlyEnglish",
  SameTitleAndText = "قرار دادن عنوان و متن یکسان برای تبلیغ امکان‌پذیر نیست",
}

export const validateOnlyEnglish = (input: string) => {
  const regex = /^[A-Za-z0-9۱-۹ ]*$/;
  if (regex.test(input)) {
    return TitleAndTextErrors.OnlyEnglish;
  }
};

export enum LinkErrors {
  ForbiddenPlatform = "ForbiddenPlatform",
  ForbiddenLinks = "ForbiddenLinks",
  WrongBaleUrl = "WrongBaleUrl",
}

export const validateForbiddenPlatforms = (input: string) => {
  // check for instagram, telegram and ita links
  const regex =
    /(?:(?:http|https):\/\/)?(?:www\.)?(?:telegram\.org|telegram\.me|t\.me|t\.org|instagram\.com|instagr\.am|instagr\.com|eitaa\.com|eitaa\.ir|rubika\.ir|rubika\.com)(?:\/(\w+))?/gim;
  if (regex.test(input)) {
    return LinkErrors.ForbiddenPlatform;
  }
};

export const validateBaleUrl = (value: string) =>
  WrongBaleLink.test(value) ? LinkErrors.WrongBaleUrl : undefined;

export const removeRepetitiveNewLines = (input: string) => {
  return input.replace(/\n+/g, "\n");
};
